import React from 'react'
import styled from 'styled-components'
import { useLastTruthy } from '../../hooks/useLast'
import { AdvancedSwapDetails, AdvancedSwapDetailsProps } from './AdvancedSwapDetails'

const AdvancedDetailsFooter = styled.div<{ show: boolean }>`
    padding-top: calc(16px + 2rem);
    padding-bottom: 16px;
    margin-top: -4rem;
    width: 100%;
    //max-width: 544px;
    //max-width: 574px;
    max-width: 662px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    color: ${({ theme }) => theme.text2};
    background-color: #202231;
    // background-color: ${({ theme }) => theme.advancedBG};
    z-index: -1;
    padding-right: 10px;
    padding-left: 10px;

    transform: ${({ show }) => (show ? 'translateY(0%)' : 'translateY(-100%)')};
    transition: transform 300ms ease-in-out;
`

export default function AdvancedSwapDetailsDropdown({ trade,userdata, ...rest }: AdvancedSwapDetailsProps) {
    const lastTrade = useLastTruthy(trade)
    return (
        <AdvancedDetailsFooter show={Boolean(trade)} style={{backgroundColor:'#fff'}}>
            <AdvancedSwapDetails {...rest} trade={trade ?? lastTrade ?? undefined} userdata={userdata} />
        </AdvancedDetailsFooter>
    )
}
